<script context="module">
  import {
    CanvasPoolManager,
    CachedRenderer,
  } from "../util/fast-canvas-pool.js";
</script>

<script>
  import { link } from "../util/anchor-link.js";
  import LinkButton from "./LinkButton.svelte";
  import StaticArtwork from "./StaticArtwork.svelte";
  import {
    createEmptyEncoding,
    createRandomEncoding,
    hexToEncoding,
    encodingToHex,
  } from "bitframes";
  import { writable } from "svelte/store";
  import { onMount } from "svelte";
  import {
    fetchLatestOpenEditionMints,
    fetchTokens,
  } from "../util/data-fetcher";
  import { withIntersection } from "../util/with-intersection";
  import {
    colorSpace,
    getBackground,
    LINK_GALLERY,
  } from "../util/constants.js";
  import RoundLinkButton from "./RoundLinkButton.svelte";
  const emptyHex = encodingToHex(createEmptyEncoding());
  const count = 4;
  const placeholders = Array(count)
    .fill()
    .map((_, i) => {
      return {
        placeholder: true,
        token_id: `placeholder-${i}`,
        seed: emptyHex,
      };
    });

  let mints = writable(placeholders);
  let _curMints;
  const unsubMints = mints.subscribe((v) => {
    _curMints = v;
  });
  const DIMENSIONS = 768;
  const pool = CanvasPoolManager({
    hatch: true,
    hatchContours: true,
    maxPaintsPerFrame: 1,
    maxPerFrame: 16,
    colorSpace,
    width: DIMENSIONS,
    height: DIMENSIONS,
  });

  const poolAction = pool.action;

  let hasFetched = false;
  onMount(() => {
    hasFetched = false;
    return () => {
      unsubMints();
      pool.destroy();
    };
  });

  async function doFetch() {
    if (hasFetched) return;
    hasFetched = true;
    const newMints = await fetchLatestOpenEditionMints();
    mints.update(() => {
      const rev = newMints.slice();
      rev.reverse();
      return rev;
    });
  }

  function getBG(seed) {
    return getBackground({ system: seed.charAt(1) === "1" ? 0x01 : 0x00 });
  }
</script>

<div
  class="container"
  use:withIntersection={{
    onChange: (visible) => {
      if (visible) doFetch();
    },
  }}
>
  {#if _curMints.length === 0}<em
      >Indexing results from the blockchain, this might take a few minutes...</em
    >{/if}
  <div class="gallery">
    {#each _curMints as cell, i (cell.token_id)}
      <a
        use:link
        href={cell.placeholder ? "" : `/gallery/token/${cell.token_id}`}
      >
        <div
          class="cell"
          data-index={i}
          data-encoding={cell.seed}
          style="--bg: {getBG(cell.seed)}"
          use:poolAction
        >
          <!-- <StaticArtwork
            canvasResolution={1024}
            lazyRender={true}
            displayPadding={0}
            encoding={hexToEncoding(cell.seed)}
          /> -->
        </div>
      </a>
    {/each}
  </div>

  <div class="view-all-button-container">
    <RoundLinkButton text="VIEW ALL" href={`/${LINK_GALLERY}`}
    ></RoundLinkButton>
    <!-- <LinkButton to="/gallery">VIEW ALL</LinkButton> -->
  </div>
</div>

<style>
  .cell {
    width: 256px;
    height: 256px;
  }
  .view-all-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: var(--main-gutter-vertical);
    /* margin-bottom: 20px; */
  }
  .container {
    --cell-size: 128px;
    --columns: 4;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    /* align-items: flex-start; */
  }
  .header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .gallery {
    /* margin-top: 20px; */
    margin-bottom: 0px;
    flex-grow: 1;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px;
    flex-flow: wrap;

    grid-template-columns: repeat(
      var(--columns),
      minmax(var(--cell-size), 1fr)
    );
    display: grid;
    grid-gap: 20px;
    box-sizing: border-box;
  }
  .cell {
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    cursor: pointer;
    background: var(--bg);
  }

  @media screen and (max-width: 800px) {
    .container {
      /* padding: 20px; */
      --gap: 20px;
      --columns: 2;
    }
  }
</style>
